import React from 'react';
import AdminDashboard from '../../containers/app/superAdminScreens/adminDashboard';
import AdminSettings from '../../containers/app/superAdminScreens/adminSettings';
import Complaints from './../../containers/app/superAdminScreens/complaints/index';
import Customers from './../../containers/app/superAdminScreens/customers/index';
import Trips from './../../containers/app/superAdminScreens/trips/index';

const SuperAdminRoutes = [
  {
    id: 1,
    name: 'Dashboard',
    component: <AdminDashboard />,
    exact: 'exact',
    path: '',
    icon: 'dashboard',
  },
  {
    id: 2,
    name: 'Customers',
    component: <Customers />,
    exact: 'exact',
    path: 'customers',
    icon: 'groups',
  },
  {
    id: 2,
    name: 'Complaints',
    component: <Complaints />,
    exact: 'exact',
    path: 'complaints',
    icon: 'feedback',
  },
  {
    id: 2,
    name: 'Matches',
    component: <Trips />,
    exact: 'exact',
    path: 'matches',
    icon: 'card_travel',
  },
  {
    id: 3,
    name: 'Settings',
    component: <AdminSettings />,
    exact: 'exact',
    path: 'adminSettings',
    icon: 'settings',
  },
];

export { SuperAdminRoutes };
